import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, ThirtyFpsSharp } from "@mui/icons-material";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { connect } from "react-redux";
import Progress from "./CustomTool/Progress";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { fetchLoadUnload, fetchWayBridgeDetail } from "./API";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
  isValidItem,
  getlocalstoragedate,
  setlocalstoragedate,
  applyTrimOnObjectValues,
  csvFileName,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import VehicleUnload from "./VehicleUnload";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import ResetDate from "../images/resetdate.png";
import MaterialTable from "./CustomTool/MaterialTable";
import CustomerMaster from "./CustomerMaster";
import LedgerMaster from "./LedgerMaster";
import TripItemEntry from "./TripItemEntry";
import CtART from "./CustomTool/ResponsiveTable";

class DriverMaster extends Component {
  state = {
    formData: {
      bint_srno: "",
      txtWayBridge: "",
    },

    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: "Sr No.",
      },
      {
        accessorKey: "vac_waybridgename",
        header: " Way Bridge Name",
      },
    ],
    rows: [],

    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,

    dataLoadStatus: true,
    ARD: null,
  };

  //#region Component
  componentDidMount() {
    {
      !this.props.showHeading && (document.title = "RA : Way Bridge Master");
    }
    this.props.setActiveMenu("WayBridgeMaster");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeRowsPerPageOtherDetail = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };

  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // New : Sales Item Entry'
          alertMessage={<TripItemEntry />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      // excludeKeysArray: ["chkReceiptGenerated"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "LoadWayBridge",
        bint_acid: localStorage.getItem("acid"),
      };
      fetchWayBridgeDetail(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          if (res.data.WayBridgeList && res.data.WayBridgeList.length > 0) {
            rows = res.data.WayBridgeList;
            rowsCount = rows.length;
          }
          this.setState({
            dataLoadStatus,
            rows,
            rowsCount,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
    document.getElementById("txtWayBridge").focus();
  };

  clearInfo = () => {
    let bint_srno = "",
      txtWayBridge = "";

    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno,
          txtWayBridge,
        },
      },
      () => {
        document.getElementById("txtWayBridge").focus();
      }
    );
  };

  validatWayBridgeMaster = () => {
    const { txtWayBridge } = this.state.formData;

    if (!txtWayBridge.trim()) {
      this.props.toastErrorMsg("Enter Way Bridge Name", "txtWayBridge");
      return false;
    }
    return true;
  };

  handleARDonActionClick_Edit = (row) => {
    console.log("row", row);
    // console.log('row.original["bint_srno"]', row.original["bint_srno"]);
    const bint_srno = row.getValue("bint_srno"),
      txtWayBridge = row.getValue("vac_waybridgename");
    // const rows2 = row.original.CheckToDoList;
    // console.log("rows2", rows2);
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno,
        txtWayBridge,
      },
    });
    window.scrollTo(0, 0);
    document.getElementById("txtWayBridge").focus();
  };

  SaveWayBridge = () => {
    this.trimFormData(() => {
      if (this.validatWayBridgeMaster()) {
        let dataLoadStatus = false;
        this.props.notifyProcessing();
        this.setState({ dataLoadStatus: false }, () => {
          const reqData = {
            Op: "SaveWayBridge",
            bint_acid: localStorage.getItem("acid"),
            bint_srno: this.state.formData.bint_srno,
            vac_waybridgename: this.state.formData.txtWayBridge,
            bint_acyear: localStorage.getItem("ACY"),
            vac_company: localStorage.getItem("CompanyName"),
            dec_opbalancecrdr: "DR",
          };
          fetchWayBridgeDetail(reqData)
            .then((res) => {
              this.props.updateProcessing(res.data.msgType, res.data.message);
              let dataLoadStatus = true,
                rows = this.state.rows,
                rowsCount = rows.length;
              if (res.data.msgType === "success") {
                if (
                  res.data.WayBridgeList &&
                  res.data.WayBridgeList.length > 0
                ) {
                  rows = res.data.WayBridgeList;
                  rowsCount = rows.length;
                }
              }
              this.setState(
                {
                  dataLoadStatus,
                  rows,
                  rowsCount,
                },
                () => {
                  if (res.data.msgType === "success") {
                    this.clearInfo();
                  }
                }
              );
            })
            .catch((error) => {
              console.log(
                "Unknown error occurred in SaveWayBridgeMaster.",
                error
              );
            });
        });
      }
    });
  };

  handleARDonActionClick_Delete = (row) => {
    const bint_srno = row.getValue("bint_srno"),
      WayBridge = row.getValue("vac_waybridgename");
    this.DeleteData(bint_srno, WayBridge);
  };

  DeleteData = (bint_srno, WayBridge) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Way Bridge : " + WayBridge + " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteWayBridge(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteWayBridge = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteWayBridge",
      bint_acid: localStorage.getItem("acid"),
      bint_srno: bint_srno,
      // bol_list: true,
    };
    fetchWayBridgeDetail(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.WayBridgeList && res.data.WayBridgeList.length > 0) {
            rows = res.data.WayBridgeList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.onFormLoad();
              this.clearInfo();
            }
          );
          document.getElementById("txtWayBridge").focus();
        }
      })

      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Check list. " + error
        );
      });
    return false;
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };
  render() {
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {this.props.showHeading == true && (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="title"
          >
            <label
              htmlFor="Title"
              style={{ fontSize: "25px", color: "#6f7689" }}
            >
              <b>Way Bridge Master</b>
            </label>
          </Grid>
        )}

        <Grid
          container
          direction="column"
          spacing={2}
          // marginTop={0}
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Grid
              container
              direction="row"
              spacing={2}
              // marginTop={0}
              justifyContent="center"
              alignItems="flex-start"
            >
              <Grid item>
                <CtTxt
                  id="txtWayBridge"
                  value={this.state.formData.txtWayBridge}
                  handleOnChange={this.handleOnChange}
                  label="Way Bridge Name*"
                  width={250}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  defaultAction={this.SaveWayBridge}
                />
              </Grid>{" "}
            </Grid>

            <Grid
              container
              direction="row"
              // justifyContent="center"
              alignItems="flex-start"
              spacing={2}
              margin={1}
            >
              <Grid item>
                <CtBtn label="Save" onClick={this.SaveWayBridge} />
              </Grid>

              <Grid item>
                <CtBtn
                  label="New"
                  onClick={this.clearInfo}
                  variant={"outlined"}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.txtWayBridge
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />

        <Grid item marginTop={3} className="maintable">
          <CtART
            rowsdata={this.state.rows}
            columnsdata={this.state.columnsdata}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            csvFileName={csvFileName("WayBridgeMaster")}
            rowIconAction={[
              {
                label: "Edit",
                onClick: this.handleARDonActionClick_Edit,
                icon: "Edit",
                className: "secondary-button",
              },
              {
                label: "Delete",
                onClick: this.handleARDonActionClick_Delete,
                icon: "delete",
                className: "delete-button",
              },
            ]}
            showColumnFilters={false}
            actionColSize={20}
            hideColIdList={["bint_srno"]}
            density={"compact"}
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(DriverMaster))));
